import { createSlice } from "@reduxjs/toolkit";

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboards: [],
    dashboardCards: null,
    graphData: null,
    caseSummary: [],
    statusSummary: [],
    financialReports: [],
    leadReports: [],
    feedbackReports: [],
    jobSummaryReports: [],
    referrersReports: [],
  },
  reducers: {
    getDashboardCardAction: (state, { payload }) => {},
    setDashboardCardAction: (state, { payload }) => {
      console.log("payload", payload);
      state.dashboardCards = payload;
    },

    getDashboardGraphDataAction: (state, { payload }) => {},
    setDashboardGraphDataAction: (state, { payload }) => {
      console.log("payload", payload);
      state.graphData = payload;
    },

    getFinancialReportsAction: (state, { payload }) => {},
    setFinancialReportsAction: (state, { payload }) => {
      console.log("payload", payload);
      state.financialReports = payload;
    },

    getLeadReportsAction: (state, { payload }) => {},
    setLeadReportsAction: (state, { payload }) => {
      console.log("payload", payload);
      state.leadReports = payload;
    },

    getFeedbackReportsAction: (state, { payload }) => {},
    setFeedbackReportsAction: (state, { payload }) => {
      console.log("payload", payload);
      state.feedbackReports = payload;
    },

    getJobSummaryReportsAction: (state, { payload }) => {},
    setJobSummaryReportsAction: (state, { payload }) => {
      console.log("payload", payload);
      state.jobSummaryReports = payload;
    },

    getReferrersReportsAction: (state, { payload }) => {},
    setReferrersReportsAction: (state, { payload }) => {
      console.log("payload", payload);
      state.referrersReports = payload;
    },
  },
});

const {
  getDashboardCardAction,
  setDashboardCardAction,
  getDashboardGraphDataAction,
  setDashboardGraphDataAction,
  getFinancialReportsAction,
  setFinancialReportsAction,
  getLeadReportsAction,
  setLeadReportsAction,
  getFeedbackReportsAction,
  setFeedbackReportsAction,
  getJobSummaryReportsAction,
  setJobSummaryReportsAction,
  getReferrersReportsAction,
  setReferrersReportsAction,
} = dashboardSlice.actions;

export {
  getDashboardCardAction,
  setDashboardCardAction,
  getDashboardGraphDataAction,
  setDashboardGraphDataAction,
  getFinancialReportsAction,
  setFinancialReportsAction,
  getLeadReportsAction,
  setLeadReportsAction,
  getFeedbackReportsAction,
  setFeedbackReportsAction,
  getJobSummaryReportsAction,
  setJobSummaryReportsAction,
  getReferrersReportsAction,
  setReferrersReportsAction,
};

export default dashboardSlice.reducer;
